import { useEffect, useRef, useState } from 'react'

export default function HorizontalScroll({ children, flushMargins }) {
    const scrollRef = useRef(null)
    const [canScrollLeft, setCanScrollLeft] = useState(false)
    const [canScrollRight, setCanScrollRight] = useState(false)

    useEffect(function () {
        function checkScroll() {
            if (scrollRef.current) {
                const { scrollLeft, scrollWidth, clientWidth } =
                    scrollRef.current
                setCanScrollLeft(scrollLeft > 0)
                setCanScrollRight(scrollLeft + clientWidth < scrollWidth)
            }
        }

        checkScroll()

        const scrollElement = scrollRef.current
        if (scrollElement) {
            scrollElement.addEventListener('scroll', checkScroll)
            window.addEventListener('resize', checkScroll)
        }

        return function () {
            if (scrollElement) {
                scrollElement.removeEventListener('scroll', checkScroll)
                window.removeEventListener('resize', checkScroll)
            }
        }
    }, [])

    const scrollLeft = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({ left: -200, behavior: 'smooth' })
        }
    }

    const scrollRight = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({ left: 200, behavior: 'smooth' })
        }
    }

    let className = 'horizontal-scroll-inner'
    if (flushMargins) {
        className += ' flush-margins'
    }

    return (
        <div className="horizontal-scroll">
            <button
                title="Scroll Left"
                className={`scroll-arrow left ${!canScrollLeft ? 'scroll-arrow-hidden' : ''}`}
                onClick={scrollLeft}
            ></button>
            <div className={className} ref={scrollRef}>
                {children}
            </div>
            <button
                title="Scroll Right"
                className={`scroll-arrow right ${!canScrollRight ? 'scroll-arrow-hidden' : ''}`}
                onClick={scrollRight}
            ></button>
        </div>
    )
}
